import React from 'react';
import TopIndices from './TopIndices';
import PerformanceChart from '../PerformanceChart/PerformanceChart';

function MarketIndex()
{
    return (
        <div className="market-index">
            <TopIndices/>
            <PerformanceChart name="chart-market-performance"/>
        </div>
    );
}

export default MarketIndex;
